export default __webpack_public_path__ + "static/media/curly-brackets-down-xl.03bbec56.svg";